// Outer
import React, { useState } from 'react';
import {
  Box,
  Button,
  Typography,
  Paper,
  Link,
} from '@mui/material';

// Inner
import SimpleTable from '@/common/components/SimpleTable';
import CreateKnowledgeBaseCategoryForm from '@/common/pages/home/knowledgeBase/knowledgeBaseCategories/CreateKnowledgeBaseCategoryForm';
import UpdateKnowledgeBaseCategoryForm from '@/common/pages/home/knowledgeBase/knowledgeBaseCategories/UpdateKnowledgeBaseCategoryForm';

const columns = [
  {
    "name": "Name",
    "accessor": "name",
  },
  {
    "name": "Icon Name",
    "accessor": "iconName",
  },
];

export default function KnowledgeBaseCategoriesFormTab({ onClose, knowledgeBaseCategories, refetchKnowledgebasecategory }: any) {
  const [knowledgebasecategoriesEdit, setKnowledgebasecategoriesEdit] = useState(false);
  const [editState, setEditState] = useState('');
  const [knowledgebasecategoriesId, setKnowledgebasecategoriesId] = useState(0);

  const handleDissmissKnowledgebasecategoriesEdit = () => {
    setKnowledgebasecategoriesEdit(false);
    setEditState('');
  };

  const handleEditKnowledgebasecategories = (state: string) => {
    setKnowledgebasecategoriesEdit(true);
    setEditState(state);
  };

  return (
    <Box padding={2} display="flex" flexDirection="column">
      <Box marginBottom={2} display="flex" justifyContent="space-between">
        <Typography variant="h6">Knowledge Base Categories</Typography>
        {
          !knowledgebasecategoriesEdit ? (
            <Button
              variant="outlined"
              color="primary"
              onClick={() => handleEditKnowledgebasecategories('create')}
            >
              New Category
            </Button>
          ) : (
            <Link
              style={{ cursor: "pointer" }}
              onClick={handleDissmissKnowledgebasecategoriesEdit}
            >&lt; back</Link>
          )
        }

      </Box>

      {
        (!knowledgebasecategoriesEdit && !!knowledgeBaseCategories?.length) && (
          <Box marginBottom={2} width={"100%"}>
            <Paper
              variant='outlined'
              style={{ overflowX: "auto" }}
            >
              <SimpleTable
                columns={columns}
                rows={knowledgeBaseCategories}
                onSelect={(id: number) => {
                  setKnowledgebasecategoriesId(id);
                  handleEditKnowledgebasecategories('update')
                }}
              />
            </Paper>
          </Box>
        )
      }

      { // state 'update', 'create'
        knowledgebasecategoriesEdit && (
          <>
            {
              (editState === 'create') ? (
                <CreateKnowledgeBaseCategoryForm
                  refetch={refetchKnowledgebasecategory}
                  onClose={handleDissmissKnowledgebasecategoriesEdit}
                />
              ) : (
                <UpdateKnowledgeBaseCategoryForm
                  knowledgebasecategoriesId={knowledgebasecategoriesId}
                  refetch={refetchKnowledgebasecategory}
                  onClose={handleDissmissKnowledgebasecategoriesEdit}
                  knowledgeBaseCategories={knowledgeBaseCategories}
                />
              )
            }
          </>
        )
      }

      <Button variant="outlined" color="primary" onClick={onClose}>
        Cancel
      </Button>
    </Box>
  );
}
